export const QuestionsData = [
  {
    title: 'What is a Persistent Platform?',
    description:
      "A Persistent Platform is all about creating a consistent strategy that flows through every part of your brand. It's made up of the following elements: Persistent Humans, Persistent Relationships, Persistent Purpose, and, the new kid on the block, Persistent Product Edge.",
  },
  {
    title: 'What isn’t a Persistent Platform?',
    description:
      "A Persistent Platform isn’t just a catchy slogan or a flash-in-the-pan campaign. It’s not something you swap out every time someone new joins the team. It's your brand’s rock-solid foundation.",
  },
  {
    title: 'What is a Persistent Product Edge?',
    description:
      'Your Persistent Product Edge is made up of your Product Edge (defined during the BVA) and product lens/es (a set of inspirational product-led strategies and tactics). It is the most single-minded articulation of your product’s benefits and exists to communicate your product in the most irresistible way to consumers.',
  },
  {
    title: 'What isn’t a Persistent Product Edge?',
    description:
      'A Persistent Product Edge should not span multiple sections of the template but focus on product intrinsic and truths . It should be product-centric to its core. If your Persistent Product Edge isn’t product-centric, think about simplifying or moving those extra details to another part of the template.',
  },
  {
    title: 'What are the definitions of Persistent Humans, Persistent Relationship, and Persistent Purpose?',
    description:
      'Persistent Humans is a definition that goes beyond demographics and seeks to embody a unified behavior or mindset of a specific audience. Persistent Relationship taps into a long-standing, pre-existing relational truth. Persistent Purpose reflects a unique role a brand can take in an audience’s life.',
  },
  {
    title: 'How do I define my Persistent Product Edge',
    description:
      "Start by boiling down your product's key point of difference and learning from your product-centric lens/es. Take a look at the BVA template for more details.",
  },
  {
    title: 'Who can I contact to provide insight for the Persistent Product Edge?',
    description: 'Got questions? Need more explanation of the Persistent Platform? Contact Intercom.',
  },
]
